module.exports = __webpack_public_path__ + "img/mc_donald.4e74672e.webp";